import * as React from "react";
import Svg, { Circle, Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

type ChatIllustrationProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function ChatIllustration({
  className,
  ...props
}: ChatIllustrationProps) {
  return (
<Svg
      width={135}
      height={81}
      viewBox="0 0 135 81"
      fill="none"
      {...props}
    >
      <Path
        d="M133.61 76.44c1.974-5.22-6.311-3.873-6.598-3.73l-.43 3.73c-18.244 3.097-34.565 1.29-40.446 0v-8.033L70.933 76.44c-10.097.689-15.781-2.776-18.214-4.16l1.434-4.732-20.366 8.032-6.598-4.447c-3.49.957-11.76 3.27-16.924 4.877-5.163 1.606-3.585 2.295-2.15 2.438 41.018 1.004 123.487 3.299 125.495-2.008z"
        fill="#A0A0A0"
        stroke="#EDE6E1"
        strokeWidth={1.05083}
        strokeLinecap="round"
      />
      <Path
        d="M113.532 20.22c.478 1.912.286 5.593-4.303 5.02-4.59-.574-2.582-8.606 1.577-7.602M94.023 7.742c7.124.717 23.206 1.52 30.55-1.004"
        stroke="#1A202C"
        strokeWidth={1.05083}
        strokeLinecap="round"
      />
      <Path
        d="M127.728 3.725l-1.133 72.76c-.008.543-.43.99-.972 1.028-9.775.675-29.435 1.302-38.697-1.004a1.016 1.016 0 01-.761-1.033l2.657-72.723a1.049 1.049 0 011.068-1.015c6.885.126 22.313.133 36.69-.738M94.598 72.426c5.498.048 17.698-.086 22.517-1.004M60.322 70.704c.86.334 3.07 1.176 5.02 1.864M76.67 12.042c1.1.574 3.585 1.549 4.733.86"
        stroke="#1A202C"
        strokeWidth={1.05083}
        strokeLinecap="round"
      />
      <Path
        d="M76.107 4.886l9.556 3.244c1.05.356.878 1.643-.227 1.55-4.699-.393-8.274-2.395-9.975-3.94-.6-.545-.121-1.114.646-.854z"
        fill="#A0A0A0"
        stroke="#EDE6E1"
        strokeWidth={1.05083}
        strokeLinecap="round"
      />
      <Path
        d="M87.572 15.63l-16.78 60.525c-6.426 1.147-14.63-2.103-17.929-3.872 2.18-8.491 15.394-49.577 21.514-68.413l13.768 4.733M65.051 25.668l-6.725-5.33a1.05 1.05 0 00-1.515.223L25.18 65.97M23.89 68.265l10.184 7.314 31.553-48.333M2.377 71.851c.797 1.328 2.774 3.886 4.702 4.257.29.056.575-.079.774-.298l40.944-44.996c.413-.454.351-1.164-.116-1.562-.941-.8-2.195-1.96-3.209-3.152-.428-.504-1.21-.56-1.667-.082L1.085 70.704"
        stroke="#1A202C"
        strokeWidth={1.05083}
        strokeLinecap="round"
      />
      <Circle
        cx={5.81979}
        cy={71.1342}
        r={0.525416}
        fill="#1A202C"
        stroke="#EDE6E1"
        strokeWidth={0.0965557}
      />
      <Circle
        cx={30.4858}
        cy={69.9887}
        r={0.525416}
        fill="#1A202C"
        stroke="#EDE6E1"
        strokeWidth={0.0965557}
      />
      <Circle
        cx={59.1713}
        cy={26.1001}
        r={0.525416}
        fill="#1A202C"
        stroke="#EDE6E1"
        strokeWidth={0.0965557}
      />
      <Circle
        cx={45.1186}
        cy={29.2529}
        r={0.525416}
        fill="#1A202C"
        stroke="#EDE6E1"
        strokeWidth={0.0965557}
      />
      <Path
        d="M44.688 25.382l10.183-2.581M57.596 19.933l12.764-4.015"
        stroke="#1A202C"
        strokeWidth={1.05083}
        strokeLinecap="round"
      />
    </Svg>
  );
}

export default ChatIllustration;